import I18nProvider from './I18n.provider';

export { LOCALES } from './locales';

export default I18nProvider;
